
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#69FFF5","d":"M19.54 43.691 24.57 29l-5.2-14.91L14.512 0l42 29-42 29z"}}),_c('path',{attrs:{"d":"m8.45 4.553 3.864 11.212 5.315 15.232-5.143 15.018-4.01 11.414L46.751 31 8.449 4.553z","stroke":"#F26A02","stroke-width":"1.5","vector-effect":"non-scaling-stroke"}})])])
          )
        }
      }
    